import ReactCountryFlag from "react-country-flag";
import {playerToString} from "../../util/StringUtils";
import {useCallback, type CSSProperties} from "react";
import {useNavigate} from "react-router-dom";
import type {Player} from "../../types/domain";

// Accept any object with these fields — both Player and PlayerDetail satisfy this.
type PlayerLike = Pick<Player, "id" | "firstname" | "lastname" | "nickname" | "nationality"> & {
  elo?: number;
};

interface PlayerNameWithFlagProps {
  player: PlayerLike | null;
  color?: string;
  notLink?: boolean;
  includeElo?: boolean;
  aliasOnly?: boolean;
}

function PlayerNameWithFlag(props: PlayerNameWithFlagProps) {

    const style: CSSProperties | undefined = props.color ? {color: props.color} : undefined
    const navigate = useNavigate();
    const handleOnClick = useCallback((id: number) => navigate('/players/' + id), [navigate]);

    if (props.player === null) {
        return <div className="player-row">-</div>
    }

    const player = props.player;
    const className = props.notLink ? "player" : "player clickable link-color";

    return (
      <div className="player-row" onClick={() => props.notLink ? null : handleOnClick(player.id)}>
        <ReactCountryFlag countryCode={player.nationality ?? "UN"} svg title={player.nationality ?? "UN"} className="flag me-1" />
        <span className={className} style={style}>
          {playerToString(player, props.includeElo, props.aliasOnly)}
        </span>
      </div>
    );
}

export default PlayerNameWithFlag
